import { createReducer, on } from '@ngrx/store';

import { ThemeActions } from './theme.actions';
import { initialThemeState, ThemeState } from './theme.model';

export const themeStateReducer = createReducer<ThemeState>(
  initialThemeState,

  on(ThemeActions.initializeMode, (state, { theme }): ThemeState => ({
    ...theme,
  })),
  on(ThemeActions.setSystemMode, (state, { mode }): ThemeState => ({
    ...state,
    systemMode: mode,
  })),

  on(ThemeActions.setAppMode, (state, { mode }): ThemeState => ({
    ...state,
    appMode: mode,
  }))
);
